export const MonthlyPerformanceReports = {
  airports: {
    top: {
      id: 'div-gpt-ad-1503353387500-3',
      sizes: [728, 90],
      adSlot: '/1010197/BS_AirportMonthlyPerformanceReport_top_728x90',
    },
    topMobile: {
      id: 'div-gpt-ad-1503353387500-2',
      sizes: [[320, 100], [320, 50]],
      adSlot: '/1010197/BS_AirportMonthlyPerformanceReport_top_320x100',
    },
  },
  airlines: {
    top: {
      id: 'div-gpt-ad-1503353229329-3',
      sizes: [728, 90],
      adSlot: '/1010197/BS_AirlineMonthlyPerformanceReport_top_728x90',
    },
    topMobile: {
      id: 'div-gpt-ad-1503353229329-2',
      sizes: [[320, 100], [320, 50]],
      adSlot: '/1010197/BS_AirlineMonthlyPerformanceReport_top_320x100',
    },
  },
};



// WEBPACK FOOTER //
// ./modules/MonthlyPerformanceReports/components/ads.js